import { ProjectCategoryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectCategory = createAction(
  '[ProjectCategory] Load ProjectCategory'
);

export const loadProjectCategorySuccess = createAction(
  '[ProjectCategory] Load ProjectCategory Success',
  props<{ projectCategory: ProjectCategoryDto[] }>()
);

export const loadProjectCategoryFailure = createAction(
  '[ProjectCategory] Load ProjectCategory Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addProjectCategory = createAction(
  '[ProjectCategory] Add ProjectCategory',
  props<{ newProjectCategory: ProjectCategoryDto[] }>()
);

export const addProjectCategorySuccess = createAction(
  '[ProjectCategory] Add ProjectCategory Success',
  props<{ newProjectCategory: ProjectCategoryDto[] }>()
);

export const addProjectCategoryFailure = createAction(
  '[ProjectCategory] Add ProjectCategory Failure',
  props<{ error: any }>()
);

/**
 * Update ProjectCategory Collection Actions
 */
export const updateProjectCategory = createAction(
  '[ProjectCategory] Update ProjectCategory',
  props<{ updateProjectCategory: ProjectCategoryDto[] }>()
);

export const updateProjectCategorySuccess = createAction(
  '[ProjectCategory] Update ProjectCategory Success',
  props<{ updateProjectCategory: ProjectCategoryDto[] }>()
);

export const updateProjectCategoryFailure = createAction(
  '[ProjectCategory] Update ProjectCategory Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectCategory Collection Actions
 */
export const removeProjectCategory = createAction(
  '[ProjectCategory] Remove ProjectCategory',
  props<{ ids: string[] }>()
);

export const removeProjectCategorySuccess = createAction(
  '[ProjectCategory] Remove ProjectCategory Success',
  props<{ ids: string[] }>()
);

export const removeProjectCategoryFailure = createAction(
  '[ProjectCategory] Remove ProjectCategory Failure',
  props<{ error: any }>()
);
